import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Spinner.module.scss'
import { ReactComponent as SpinnerIcon } from 'assets/icons/spinner.svg'

export const Spinner = ({ isCentered, width = 30, height = 30, color, className }) => {
  const classList = classNames(styles.spinner, className, {
    [styles.centered]: isCentered,
    [styles.themeBlue]: color === 'blue',
    [styles.themeWhite]: color === 'white',
    [styles.themeBlack]: color === 'black',
    [styles.themeGray]: color === 'gray',
  })

  return <SpinnerIcon width={width} height={height} className={classList} />
}

Spinner.propTypes = {
  isCentered: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.oneOf(['blue', 'white', 'gray', 'black']),
}
